<template>
  <div data-tags-filter :class="$style.component">
    <div :class="$style.wrapper">
      <tag
        @click="remove(tag)"
        v-for="(tag, index) in tags"
        :options="options"
        :key="index">
        {{ tag.value }}
      </tag>
    </div>
  </div>
</template>

<script>
import vueTypes from 'vue-types'
import Tag from './Tag'

export default {
  name: 'TagsFilter',

  props: {
    tags: vueTypes.array,
    options: vueTypes.object
  },

  components: {
    Tag
  },

  methods: {
    remove (value) {
      this.$emit('remove', value)
    }
  }
}
</script>

<style module>
  .component {
    display: grid;
    grid-template-columns: 1fr auto;
    margin: 20px 0;
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: stretch;
  }

  .title {
    color: rgba(0, 0, 0, 0.7);
    font-size: 20px;
    font-weight: 400;
    margin: 0 20px 20px 0;
  }

  .titleLight {
    composes: title;
    color: rgba(255, 255, 255, 0.7)
  }

  @media screen and (min-width: 960px) {
    .wrapper {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-gap: 20px;
    }
  }
</style>
